/**
 * CSV export helpers (2026-09-29).
 *
 * Cells that start with = + - @ (or a tab / carriage return) are prefixed
 * with an apostrophe so Excel/Sheets treat them as text — otherwise a
 * project named "=HYPERLINK(...)" becomes a live formula in the reader's
 * spreadsheet (CSV injection). Numbers are left alone.
 */
export interface CsvColumn<T> {
  label: string
  value: (row: T) => string | number | null | undefined
}

const RISKY = /^[=+\-@\t\r]/

export function csvCell(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return ''
  if (typeof v === 'number') return Number.isFinite(v) ? String(v) : ''
  let s = String(v)
  if (RISKY.test(s)) s = `'${s}`
  return /[",\n\r]/.test(s) || s !== s.trim() ? `"${s.replace(/"/g, '""')}"` : s
}

export function toCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const head = columns.map((c) => csvCell(c.label)).join(',')
  const body = rows.map((r) => columns.map((c) => csvCell(c.value(r))).join(','))
  return [head, ...body].join('\r\n') + '\r\n'
}

export function downloadCsv(filename: string, csv: string): void {
  // BOM so Excel opens UTF-8 (accents, currency symbols) correctly.
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}

export function datedName(stem: string): string {
  return `${stem}-${new Date().toISOString().slice(0, 10)}.csv`
}
